import { render, staticRenderFns } from "./TableRowMarginPerUnit.vue?vue&type=template&id=50e9910c&lang=pug&"
import script from "./TableRowMarginPerUnit.vue?vue&type=script&lang=js&"
export * from "./TableRowMarginPerUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e9910c')) {
      api.createRecord('50e9910c', component.options)
    } else {
      api.reload('50e9910c', component.options)
    }
    module.hot.accept("./TableRowMarginPerUnit.vue?vue&type=template&id=50e9910c&lang=pug&", function () {
      api.rerender('50e9910c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/tracking-sheet/table-rows/TableRowMarginPerUnit.vue"
export default component.exports